import React from 'react';
import {useNavigate, Link} from 'react-router-dom';
import {FormularioLoginStandar} from './FormularioLoginStandar';
import {LoginExterno} from './LoginExterno';

/* A function that returns a JSX element. */
export const ContentBodyLogiInternoEmpresa = (props) => {
	/* Destructuring the props object. */
	const {olvidarContraseña} = props;

	/* A hook that allows to navigate to another page. */
	const navigate = useNavigate();

	/* Returning a JSX element. */
	return (
		<div className='contentbodyLoginInterno'>
			<FormularioLoginStandar type='empresa' />
		</div>
	);
};
